import React from "react";
import AvatarC from "../../../common/avatar";
import styles from "./mobile-agent-info.module.scss";
import { MobileAgentInfoProps } from "./mobile-agent-info.interface";

const MobileAgentInfo = ({
  profileImg,
  title,
  name,
  email,
  phone,
  onClick,lastName
}: MobileAgentInfoProps) => {
  return (
    <div className={styles.agentInfo} onClick={onClick} tabIndex={26}>
      <div className={styles.title}>{title}</div>
      <div className={styles.agentWrap}>
        {profileImg && (
          <AvatarC
            label={`${name?.slice(0, 1)}${lastName?.slice(0, 1)}`}
            // image={profileImg}
            size="large"
            shape="circle"
          />
        )}
        <div className={styles.agentDetails}>
          {name !== undefined && <div className={styles.name}>{name}</div>}
          <div className={styles.email}>{email}</div>
          <div className={styles.phone}>{phone}</div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(MobileAgentInfo);
